import React from "react";

import { findIndex } from "lodash/fp";

import Divider from "@mui/material/Divider";

import type {
  BillingCreditCheckoutStep,
  BillingSubscriptionCheckoutStep,
} from "@app/analytics/account/Billing/types";

import { Row } from "@rui/Stack";

import { Step, StepState } from "./styles";

type CheckoutStepId =
  | BillingCreditCheckoutStep
  | BillingSubscriptionCheckoutStep;
type CheckoutStep = { id: CheckoutStepId; label: string };

const SUBSCRIPTION_CHECKOUT_STEPS: CheckoutStep[] = [
  {
    id: "plan",
    label: "Select plan",
  },
  {
    id: "details",
    label: "Plan details",
  },
  {
    id: "purchase",
    label: "Purchase",
  },
];

const CREDIT_CHECKOUT_STEPS: CheckoutStep[] = [
  {
    id: "credits",
    label: "Choose credits",
  },
  {
    id: "purchase",
    label: "Purchase",
  },
];

const getStepIndex = (stepId: CheckoutStepId, steps: CheckoutStep[]) =>
  findIndex(({ id }) => id === stepId, steps);

const getStepState = (
  stepId: CheckoutStepId,
  currentPage: number,
  steps: CheckoutStep[]
): StepState => {
  const stepIndex = getStepIndex(stepId, steps);
  if (currentPage === stepIndex) return "current";
  return currentPage > stepIndex ? "completed" : "pending";
};

const CheckoutStepper = ({
  currentPage,
  type,
}: {
  currentPage: CheckoutStepId;
  type: "subscription" | "credits";
}) => {
  const steps =
    type === "credits" ? CREDIT_CHECKOUT_STEPS : SUBSCRIPTION_CHECKOUT_STEPS;
  const currentPageIndex = getStepIndex(currentPage, steps);

  return (
    <Row>
      {steps.map((step, i) => {
        const stepState = getStepState(step.id, currentPageIndex, steps);
        return (
          <Row key={step.id} variant="left" spacing={1}>
            <Step state={stepState} index={i + 1}>
              {step.label}
            </Step>
            {i < steps.length - 1 && <Divider sx={{ width: "32px", mr: 1 }} />}
          </Row>
        );
      })}
    </Row>
  );
};

export default CheckoutStepper;
